import { getAxiosInstance } from '../../dataService';

const getHeaders = ssId => ({
	headers: ssId
		? {
				'X-SS-ID': ssId,
		  }
		: {},
});

// Gets the previously assigned exercises
// In the shared file because it interpolates 'program' so can be OT or PT
export const fetchPreviouslyAssigned = async ({ queryKey }) => {
	const [, apiEnv, ssId, program] = queryKey;

	return (
		await getAxiosInstance(apiEnv).get(
			`/memberProgramDetailHistory/${program}`,
			{
				...getHeaders(ssId),
			}
		)
	).data;
};
